import { Injectable } from '@angular/core';
import { isLanguageCode } from '@mkp/shared/models';
import { nullIfEmpty } from '@mkp/shared/util-api';
import { decodePunycodeEmail } from '@mkp/shared/util-format';
import {
  defaultUser,
  isUserDisplayType,
  isUserTitle,
  UpdateUser,
  User,
  UserTitle,
} from '@mkp/user/models';
import { UserDto, UserPatch } from './user.dto';

@Injectable({ providedIn: 'root' })
export class UserMapper {
  fromJson({
    id,
    email,
    firstName,
    lastName,
    emailVerified,
    profilePictureMediaApiId,
    role,
    phoneNumber,
    _version,
    settings,
    title,
  }: UserDto): User {
    return {
      id,
      email: decodePunycodeEmail(email),
      firstName,
      lastName,
      title: isUserTitle(title) ? title : (undefined as unknown as UserTitle),
      emailVerified,
      profilePictureMediaApiId,
      phoneNumber,
      role,
      settings: {
        displayType: isUserDisplayType(settings?.displayType)
          ? settings.displayType
          : defaultUser.settings.displayType,
        marketingConsentAcceptedAt: settings?.marketingConsentAcceptedAt
          ? new Date(settings.marketingConsentAcceptedAt)
          : null,
        publicationAiUsageConsent: settings?.publicationAiUsageConsent ?? null,
        language: isLanguageCode(settings?.language)
          ? settings.language
          : defaultUser.settings.language,
      },
      _version,
      _type: 'user',
    };
  }

  toJson({
    id: _id,
    phoneNumber,
    settings,
    email: _email,
    ...userProperties
  }: UpdateUser): UserPatch {
    const userDto: UserPatch = userProperties;
    const settingsDto: UserPatch['settings'] = {};

    if (phoneNumber) userDto.phoneNumber = nullIfEmpty(phoneNumber);
    if (settings?.language) settingsDto.language = settings.language;
    if (settings?.displayType) settingsDto.displayType = settings.displayType;
    if (settings?.marketingConsent !== undefined)
      settingsDto.marketingConsentAcceptedAt = settings.marketingConsent ? 'now' : null;
    if (settings?.publicationAiUsageConsent !== undefined)
      settingsDto.publicationAiUsageConsent = settings.publicationAiUsageConsent;

    if (Object.keys(settingsDto).length) userDto.settings = settingsDto;

    return userDto;
  }
}
